<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="RegisterMember" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import GravManagerWrapper from './GravManagerWrapper.vue';
import { RegisterMemberProps } from './RegisterMember.ts';
import RegisterMember from './RegisterMember.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-register-member';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<RegisterMemberProps>();
const changableProps = useChangableProps(componentName, props);

</script>
